module.exports = __webpack_public_path__ + "img/e500.4378b25e.svg";